export default __webpack_public_path__ + "static/media/Ellipse.94f33879.png";